import type { JSX } from 'react';
import type { UseFormRegister, FieldErrors } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { EditSuperAdminFormData } from './EditSuperAdminDialog.utils';

interface EditSuperAdminFormFieldsProps {
  register: UseFormRegister<EditSuperAdminFormData>;
  errors: FieldErrors<EditSuperAdminFormData>;
}

export function EditSuperAdminFormFields({
  register,
  errors,
}: EditSuperAdminFormFieldsProps): JSX.Element {
  return (
    <>
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="firstName">First Name</Label>
          <Input id="firstName" {...register('firstName')} />
          {errors.firstName && (
            <p className="text-sm text-destructive">{errors.firstName.message}</p>
          )}
        </div>
        <div className="space-y-2">
          <Label htmlFor="lastName">Last Name</Label>
          <Input id="lastName" {...register('lastName')} />
          {errors.lastName && <p className="text-sm text-destructive">{errors.lastName.message}</p>}
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="phone">Phone</Label>
        <Input id="phone" type="tel" {...register('phone')} />
      </div>
    </>
  );
}
